import { Badge } from "@insights/ui";
import { Check, CircleAlert, XCircle } from "lucide-react";
import type { BuildStatus } from "../types/build";

type BuildStatusBadgeProps = {
  status: BuildStatus;
};

export function BuildStatusBadge({ status }: BuildStatusBadgeProps) {
  if (status === "running") {
    return (
      <Badge aria-label="Incomplete" className="pending build-status-badge">
        <CircleAlert aria-hidden="true" />
        <span className="build-status-label">Incomplete</span>
      </Badge>
    );
  }

  if (status === "passed") {
    return (
      <Badge
        aria-label="Passed"
        className="success build-status-badge"
      >
        <Check aria-hidden="true" />
        <span className="build-status-label">Passed</span>
      </Badge>
    );
  }

  return (
    <Badge aria-label="Failed" className="failed build-status-badge">
      <XCircle aria-hidden="true" />
      <span className="build-status-label">Failed</span>
    </Badge>
  );
}
